// extracted by mini-css-extract-plugin
module.exports = {"button-type":"CellButtonVendor_button-type__ZQrG9","button-type-required":"CellButtonVendor_button-type-required__11iDZ"};